import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { MVKPhase } from '../types/mvk_state';
import { MVK_QUERY_STRING_PARAMS } from './middlewares/router';
export function generateInitialState(defaultState, queryString, usePlace) {
  var initialState = _objectSpread(_objectSpread({}, defaultState), {}, {
    isOfferCard: isOfferCardUsePlace(usePlace)
  });
  if (!queryString) {
    return initialState;
  }
  var array = getArrayOfMvkParams(queryString);

  // Подставляем в initialState параметры из queryString
  array.forEach(function (item) {
    switch (item.key) {
      case 'gk_mvk_flat_card':
        initialState.flat = {
          id: Number(item.value)
        };
        break;
      case 'gk_mvk_flat_plan_floor':
        initialState.sectionPhaseFilters = _objectSpread(_objectSpread({}, initialState.sectionPhaseFilters), {}, {
          selectedFloor: Number(item.value)
        });
        break;
      case 'gk_mvk_flat_plan_types':
        initialState.sectionPhaseFilters = _objectSpread(_objectSpread({}, initialState.sectionPhaseFilters), {}, {
          selectedFlatTypes: parseFlatTypes(item.value)
        });
        break;
      case 'gk_mvk_flat_popup':
        initialState.section = {
          id: Number(item.value)
        };
        break;
      case 'gk_mvk_map_popup':
        initialState.isFullScreen = !!item.value;
        break;
      case 'gk_mvk_section_popup':
        initialState.house = {
          id: Number(item.value)
        };
        break;
      default:
        break;
    }
  });

  // Нужная фаза
  if (initialState.section.id !== undefined) {
    initialState.phase = MVKPhase.SECTION;
  }
  if (initialState.flat.id !== undefined) {
    initialState.phase = MVKPhase.FLAT;
  }
  return initialState;
}
function getArrayOfMvkParams(queryString) {
  var paramsArray = queryString.replace('?', '').split('&');
  var result = [];
  for (var i = paramsArray.length - 1; i >= 0; i -= 1) {
    var _paramsArray$i$split = paramsArray[i].split('='),
      _paramsArray$i$split2 = _slicedToArray(_paramsArray$i$split, 2),
      key = _paramsArray$i$split2[0],
      value = _paramsArray$i$split2[1];
    if (MVK_QUERY_STRING_PARAMS.includes(key)) {
      result.push({
        key: key,
        value: value
      });
    }
  }
  return result;
}
function parseFlatTypes(rawFlatTypes) {
  if (!rawFlatTypes) {
    return [];
  }
  return rawFlatTypes.split(',').map(Number).filter(Number);
}
export function isOfferCardUsePlace(usePlace) {
  return usePlace === 'offer-card';
}